import { styled, TextField } from "@mui/material"
import { extraColors } from "../../utils/theme"

export const NumericInput = styled(TextField)(() => ({
  "& .MuiInputBase-root": {
    height: 32,
    fontSize: "0.75rem",
    fontWeight: 700,
    backgroundColor: extraColors.translucent5,
    borderRadius: "6px",
    border: `1px solid ${extraColors.translucent8}`,
    width: "80px",
    "& fieldset": { border: "none" },
    "&:hover": {
      backgroundColor: extraColors.translucent8,
    },
    "&.Mui-focused": {
      borderColor: extraColors.status.navyLight,
    },
  },
  "& .MuiInputBase-input": {
    padding: "0 4px",
    color: extraColors.white,
    textAlign: "center",
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      opacity: 1,
    },
  },
}))
